module.exports = __webpack_public_path__ + "img/20191210161500360截图20191210111421801.f7fd5cf2.jpg";